import React from 'react'

const Flex: React.FC<{
  centered?: boolean
  column?: boolean
  inline?: boolean
  right?: boolean
  stretch?: boolean
  wrapped?: boolean
}> = ({ centered, column, stretch, wrapped, inline, right, ...rest }) => (
  <div
    css={{
      display: inline ? 'inline-flex' : 'flex',
      flexDirection: column ? 'column' : 'row',
      width: stretch ? '100%' : null,
      flexWrap: wrapped ? 'wrap' : null,
      marginLeft: right && 'auto',
      alignItems: centered ? 'center' : null
    }}
    {...rest}
  />
)

export default Flex
